import {Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {SubscribedComponent} from "../../subscribed.component";

@Component({
    selector: 'bst-score-selector',
    templateUrl: './score-selector.component.html',
    styleUrls: ['./score-selector.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ScoreSelectorComponent),
            multi: true
        }
    ],
    standalone: false
})
export class ScoreSelectorComponent extends SubscribedComponent implements ControlValueAccessor {

  public readonly scores = [0.2, 0.4, 0.6, 0.73, 0.87];
  @Input() public value: number = null;
  public disabled: boolean = false;

  // Function to call when the value changes.
  onChange = (value: number) => {};
  // Function to call when the input is touched (when a star is clicked).
  onTouched = () => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value: number): void {
    this.value = typeof value !== 'undefined' && value !== null ? value : null;
    this.onChange(this.value);
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  setValue(value: number) {
    this.value = value;
    this.onChange(this.value);
  }

}
